// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".season-guide-checkbox-wrapper{padding:8px;border:1px solid #dce1e7;border-radius:8px}", "",{"version":3,"sources":["webpack://src/components/program/season-guide/name-and-period.scss"],"names":[],"mappings":"AAAA,+BACE,WAAA,CACA,wBAAA,CACA,iBAAA","sourcesContent":[".season-guide-checkbox-wrapper {\n  padding: 8px;\n  border: 1px solid #DCE1E7;\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
